import { Container } from '@/components/layout/Container'
import { ScentQuiz } from '@/components/fragrance/ScentQuiz'

export function ScentQuizPage() {
  return (
    <div className="pt-32 pb-24">
      <Container className="max-w-3xl">
        <p className="mb-4 text-center text-xs uppercase tracking-[0.2em] text-wd-orange">
          Scent Quiz
        </p>
        <h1 className="mb-6 text-center font-display text-4xl normal-case text-carbon">
          find your signature
        </h1>
        <p className="mb-12 text-center text-carbon/60">
          Six questions. No wrong answers. We will map your preferences to the scent families you are most likely to love.
        </p>

        <ScentQuiz />
      </Container>
    </div>
  )
}
